import { AngularEditorConfig } from "@kolkov/angular-editor";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})


export class EditorService {
  public editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '15rem',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder:
      'Nombre de la notificación: Notification name \n Número de serie: {{device.serialNumber}} \n Descripción: {{device.description}} \nCliente: {{device.organization.tenant.name}}\n Organizacion: {{device.organization.name}} \n Medidas del dispositivo: Table[] \n Propiedades del dispositivo: Table[]\n Modulos de integración: IntegratedModules[]\n Medidas: Mesaures[] \n Propiedades: Properties[] \n Eventos: Events[]',
    defaultFontName: '',
    defaultFontSize: '',
    outline: true,
    fonts: [
      {class: 'arial', name: 'Arial'}
    ],
    sanitize: false,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['fontSize']
    ]

  };

  public previewConfig: AngularEditorConfig = {
    editable: false,
    showToolbar: false,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '38vw'
  }
}

